import type { z } from "zod";

/**
 * Validate a record (e.g. `import.meta.env`, Cloudflare Worker bindings)
 * against a Zod schema and fail fast with a readable message.
 * The returned object is fully typed via the schema.
 */
export function createEnv<TSchema extends z.ZodType>(
  schema: TSchema,
  source: Record<string, unknown>,
): z.infer<TSchema> {
  const result = schema.safeParse(source);
  if (!result.success) {
    const issues = result.error.issues
      .map((issue) => `  - ${issue.path.join(".") || "(root)"}: ${issue.message}`)
      .join("\n");
    throw new Error(`Invalid environment configuration:\n${issues}`);
  }
  return result.data;
}
